// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  amchartLicence: 'CH348877456',
  am5chartLicense: 'AM5C348877456',
  testing: false,
  production: false,
  urlBlogApi: 'https://blog.betterplan.cl/wp-json/wp/v2/',
  urlApi: 'https://v1-api-dev.betterplan.cl/api/',
  urlApiV2: 'https://v2-api-dev.betterplan.cl/',
  urlGrpc: 'https://grpc-dev.betterplan.cl',
  autQr: 'https://portal-dev.betterplan.cl/confirmation/validate-ci/',
  urlLanding: 'https://landing-dev.betterplan.cl',
  urlLandingNew: 'https://bp-landingdev.webflow.io',
  urlIdentity: 'https://id-dev.betterplan.cl',
  urlPortal: 'https://portal-dev.betterplan.cl',
  auth: {
    client_id_code: 'portal-ts-code',
    client_id_pass: 'portal-ts-pass',
    issuer: 'https://id-dev.betterplan.cl',
  },
  version: 'develop-2025.6.19.21.34.12',
  name: 'Development',
  keyIntercom: 'jk4avvrn',
  firebase: {
    apiKey: 'AIzaSyBOe-7bjWm9LnqDnAXCaJo9L3F12RSs8wY',
    authDomain: 'betterplan-dev.firebaseapp.com',
    databaseURL: 'https://betterplan-dev.firebaseio.com',
    projectId: 'betterplan-dev',
    storageBucket: 'betterplan-dev.appspot.com',
    messagingSenderId: '937977179749',
    appId: '1:937977179749:web:70ba70d7c9bbe61775608c',
    measurementId: 'G-ZJMG3MR2FY',
    experimentalAutoDetectLongPolling: true,
  },
  gtmId: 'GTM-N3S8WSB',
  fintocToken: 'pk_test_Rs_unikysEJz24xfChyysvwQS4tyB-AK',
  tracker: false,
  appInsightsInstrumentationKey: 'f6850ccf-626c-4ac0-a615-fb0adeeb52b3',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
